import React from 'react';
import logo from '../images/logo.png';

const Navbar = () => {
  const navItems = [
  { label: 'Home', id: 'home' },
  { label: 'About', id: 'mercury' },
  { label: 'Experience', id: 'earth' },
  { label: 'Projects', id: 'venus' },
  { label: 'Contact', id: 'jupiter' },
];


  const handleScroll = (id) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const styles = {
    navbar: {
      position: 'fixed',
      top: 0,
      width: '100%',
      backgroundColor: 'transparent', 
      backdropFilter: 'blur(10px)',
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.3)',
      zIndex: 50,
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 24px',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logo: {
      height:'110px',
      width:'auto'
    },
    menu: {
      listStyle: 'none',
      display: 'flex',
      gap: '40px',
      margin: 0,
      padding: 0,
    },
    menuItem: {
      color: '#ffbd59',
      cursor: 'pointer',
      fontSize: '18px',
      transition: 'color 0.3s ease, text-shadow 0.3s ease, transform 0.3s ease',
      userSelect: 'none',
      marginRight:'15px'
    },
  };

  return (
    <nav style={styles.navbar}>
      <div style={styles.container}>
       <div onClick={() => handleScroll('Home')} style={{ cursor: 'pointer' }}>
  <img src={logo} alt="Logo" style={styles.logo} />
</div>
        <ul style={styles.menu}>
          {navItems.map(({label,id}) => (
            <li
              key={label}
              style={styles.menuItem}
              onClick={() => handleScroll(id)}
              onMouseEnter={(e) => {
                e.target.style.color = '#f5c963';
                e.target.style.textShadow =
                  '0 0 8px #f5c963, 0 0 15px #f5c963, 0 0 20px #f5c963';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
               e.target.style.color = '#f5c963';
                e.target.style.textShadow = 'none';
                e.target.style.transform = 'none';
              }}
            >
              {label}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
